import React, { useEffect, useState } from "react"
import { LEADERBOARDVIEW, LEADERBOARD } from "@/types/types.leaderboards"
import { useAppSelector } from "@/app/redux/hooks/reduxHooks"
import { toast } from "react-toastify"
import {
    fetchLeaderboardByStatisticNameAroundPlayer,
    fetchLeaderboardsByStatisticNameByNumber,
} from "@/app/dashboard/dashboardAction"
import { LeaderboardProps } from "@/types/types.leaderboards"
import TableComponent from "./tableComponent"
import LeaderboardToggleComponent from "./leaderboardToggleComponent"

type Props = {
    sessionTicket: string
}

const LeaderboardComponent: React.FC<Props> = (props) => {
    const { sessionTicket } = props
    const auth = useAppSelector((state) => state.auth)
    const [currentRankings, setCurrentRankings] = useState<string>(LEADERBOARD.FETCHAROUNDPLAYER)
    const [currentLeaderboard, setCurrentLeaderboard] = useState<string>(LEADERBOARDVIEW.DAILY)
    const [response, setResponse] = useState<LeaderboardProps[]>([])
    const [startingPosition, setStartingPosition] = useState<number>(0)
    const [maxResultsCount, _setMaxResultsCount] = useState<number>(50)

    const fetchLeaderboards = async () => {
        if (auth.isUserSignedIn && currentRankings === LEADERBOARD.FETCHAROUNDPLAYER) {
            const response = await fetchLeaderboardByStatisticNameAroundPlayer(
                currentLeaderboard,
                auth.playFabId!,
                sessionTicket,
                20
            )
            if (!response.success) return toast.error(`Error fetching leaderboard: ${response.data}`)
            setResponse(response.data.data.Leaderboard)
        } else if (auth.isUserSignedIn && currentRankings === LEADERBOARD.FETCHBYNUMBER) {
            const response = await fetchLeaderboardsByStatisticNameByNumber(
                currentLeaderboard,
                sessionTicket,
                maxResultsCount,
                startingPosition
            )
            if (!response.success) return toast.error(`Error fetching leaderboard: ${response.data}`)
            setResponse(response.data.data.Leaderboard)
        }
    }

    useEffect(() => {
        fetchLeaderboards()
    }, [auth.isUserSignedIn, currentLeaderboard, currentRankings])

    return (
        <section>
            <LeaderboardToggleComponent
                {...props}
                setResponse={setResponse}
                currentRankings={currentRankings}
                setCurrentRankings={setCurrentRankings}
                currentLeaderboard={currentLeaderboard}
                setCurrentLeaderboard={setCurrentLeaderboard}
                maxResultsCount={maxResultsCount}
                startingPosition={startingPosition}
                setStartingPosition={setStartingPosition}
                responseLength={response.length}
            />
            <section className="pb-5">
                {response && (
                    <TableComponent
                        response={response}
                        currentLeaderboard={currentLeaderboard}
                        currentRankings={currentRankings}
                    />
                )}
            </section>
            <LeaderboardToggleComponent
                {...props}
                setResponse={setResponse}
                currentRankings={currentRankings}
                setCurrentRankings={setCurrentRankings}
                currentLeaderboard={currentLeaderboard}
                setCurrentLeaderboard={setCurrentLeaderboard}
                maxResultsCount={maxResultsCount}
                startingPosition={startingPosition}
                setStartingPosition={setStartingPosition}
                responseLength={response.length}
            />
        </section>
    )
}

export default LeaderboardComponent
